import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import "./ActionableDialog.scss";
import {
  IActionableDialog,
  ISelectedExcessiveActivity,
} from "./IActionableDialog";
import NotificationRequest from "../../../interfaces/risk-analysis/NotificationRequest";
import { sendNotification } from "../../../utils/api/ExcessiveActivityApi";

const ActionableDialog: React.FC<IActionableDialog> = (
  iActionableDialog: IActionableDialog
): JSX.Element => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleCancelClose = () => {
    setOpen(false);
  };

  const handleSendClose = async () => {
    const notificationRequests = transformDataToNotificationRequests(
      iActionableDialog.data
    );
    await Promise.all(
      notificationRequests.map(async (notification) => {
        const notificationResponse = await sendNotification(notification);
      })
    );
    //TODO success and failure cases to alert user
    iActionableDialog.refreshView();
    setOpen(false);
  };

  const transformDataToNotificationRequests = (
    iSelectedExcessiveActivity: ISelectedExcessiveActivity
  ): Array<NotificationRequest> => {
    const notificationRequests = [] as Array<NotificationRequest>;
    Array.from(iSelectedExcessiveActivity.selectedCfaIdsByLocation).map(
      ([locationId, cfaIds]) => {
        const scanCountByCfaId: { [cfaId: string]: number } = {};
        cfaIds.forEach((cfaId) => {
          scanCountByCfaId[cfaId] =
            iSelectedExcessiveActivity.selectedScanCountsByCfaId.get(
              cfaId
            ) as number;
        });
        notificationRequests.push({
          locationId,
          cfaIds: scanCountByCfaId,
          startDate: iActionableDialog.startDate ?? new Date(),
          endDate: iActionableDialog.endDate ?? new Date(),
        });
      }
    );
    return notificationRequests;
  };

  const renderText = () => {
    return (
      <table>
        <tbody>
          <tr>
            <th>Location</th>
            <th>Cfa Id</th>
          </tr>
          {Array.from(iActionableDialog.data.selectedCfaIdsByLocation).map(
            ([locationId, cfaIds]) => {
              return cfaIds.map((cfaId) => {
                return (
                  <tr key={cfaId}>
                    <td>{locationId}</td>
                    <td>{cfaId}</td>
                  </tr>
                );
              });
            }
          )}
        </tbody>
      </table>
    );
  };

  return (
    <>
      <div>
        <Button
          className={"actionableDialogButton"}
          onClick={handleOpen}
          disabled={iActionableDialog.isDisabled}
        >
          Email
        </Button>
      </div>
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Email"}</DialogTitle>
        <DialogContent>
          Would you like to email the following cfa ids for the locations?
          {renderText()}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelClose} className="acceptButton">
            Cancel
          </Button>
          <Button className="acceptButton" onClick={handleSendClose} autoFocus>
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActionableDialog;
